import React, { useEffect } from 'react'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_AUTOMATED_LISTINGS, PRECEDENTS_CONTENT } from 'constants/controllers'
import cx from 'classnames'
import TiledMenuConsumerContainer from 'redux/containers/components/tiled-menu/TiledMenuConsumerContainer'
import ClarilisTileMenu from './ClarilisTileMenu'
import UnderlinedHeader from 'components/precedents/UnderlinedHeader'
import { URL_DOCUMENT_AUTOMATION, URL_DOCUMENT_REVIEW_HISTORY } from 'constants/links'
import { AUTOMATED_PRECEDENT_LISTINGS, DOCUMENT_DRAFTER } from 'constants/feature-flags'
import ClarilisLink from './ClarilisLink'

const Menu = ({
  view,
  aol,
  setEnterIfEmpty,
  isAdmin,
  isClarilis,
  isDocDrafter,
  isLoggedIn,
  isLoaded,
  drafterTiledMenu,
  staticTiledMenu,
  setPrecedentsTiledMenu
}) => {
  const cxNames = {
    tile: {
      borderColor: 'b--precedents-blue',
      iconColor: 'cadet-blue',
      onHoverColor: 'precedents-tile'
    },
    popover: {
      backgroundColor: 'bg-faf-grey',
      borderColor: 'b--precedents-blue',
      buttonColor: 'bg-precedents-blue'
    }
  }

  useEffect(() => {
    setPrecedentsTiledMenu(staticTiledMenu)
  }, [staticTiledMenu, setPrecedentsTiledMenu])

  useEffect(() => {
    setEnterIfEmpty(!!isAdmin)
  }, [setEnterIfEmpty, isAdmin])

  return (
    <div className={cx('bg-ghost-grey', { dn: !isLoaded })}>
      <div className='layout-width-constraint mt8'>
        {DOCUMENT_DRAFTER && !isDocDrafter && !isClarilis && (
          <section className='h6 ph6 pv4 mv8 bg-white bb-thick b--precedents-blue  flex justify-center items-center'>
            <p className='pa0 ma0'>
              To find out more about our new and existing Document Automation subscriptions, please email
              <a className='ml2' href='mailto:corporate@fromcounsel.com'>corporate@fromcounsel.com</a>.
            </p>
          </section>
        )}
        {DOCUMENT_DRAFTER && isDocDrafter && (
          <section>
            <UnderlinedHeader
              linkText='Review History'
              url={URL_DOCUMENT_REVIEW_HISTORY}
            >
              Automated Document Suites
            </UnderlinedHeader>
            <TiledMenuConsumerContainer
              data-help-item='precedentstiles'
              data-help-position='middle'
              library={view === 'browse' ? 'precedents' : view}
              getUrl={params => getUrl(PRECEDENTS_AUTOMATED_LISTINGS, { aol, ...params })}
              showInactive
              category='Automated Documents Doc Drafter'
              tiledMenu={drafterTiledMenu}
              {...{ cxNames }}
            />
          </section>
        )}
        {isClarilis && (
          <section>
            {!AUTOMATED_PRECEDENT_LISTINGS && <ClarilisLink />}
            {AUTOMATED_PRECEDENT_LISTINGS &&
              <>
                <UnderlinedHeader
                  linkText='For more information, click here'
                  url={URL_DOCUMENT_AUTOMATION}
                >
                  Automated Document Suites (Clarilis)
                </UnderlinedHeader>
                <ClarilisTileMenu {...{ cxNames }} />
              </>}
          </section>
        )}
        <section>
          {(AUTOMATED_PRECEDENT_LISTINGS || DOCUMENT_DRAFTER) && <UnderlinedHeader>Precedents/Related Resources</UnderlinedHeader>}
          <TiledMenuConsumerContainer
            data-help-item='precedentstiles'
            data-help-position='middle'
            library={view === 'browse' ? 'precedents' : view}
            getUrl={params => getUrl(PRECEDENTS_CONTENT, { aol, view, ...params })}
            showInactive
            category='Precedents'
            tiledMenu={staticTiledMenu}
            {...{ cxNames }}
          />
        </section>
      </div>
    </div>
  )
}

export default Menu
